import React from 'react';
import { PropTypes } from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { newGetVulns } from 'store/Manage/filterActions';
import { showManageLeftFilters } from 'store/Manage/actions';
import { clearFilters } from 'store/Filters/actions';
import { getData, showHostLeftFilters } from 'store/Host/actions';
import { selectIsFiltering } from 'store/Filters/selectors';
import { getVulnsByAsset, showVulnsSidebarFilters } from 'store/Contextualization/AssetDetail/actions';
import { getHostsData, showAssetsRightFilters } from 'store/HostsGeneral/actions';
import { getVulnsGeneral, showVulnsGeneralRightFilters } from 'store/ManageGeneral/actions';

import {
  FiltersHeader, HeaderTitle, ButtonsContainer, ClearAll, Close
} from '../styled';

const Header = ({ entity }) => {
  const dispatch = useDispatch();
  const isFiltering = useSelector((state) => selectIsFiltering(entity, state));

  const setHideFilter = () => {
    if (entity === 'vulns') dispatch(showManageLeftFilters(false, false));
    else if (entity === 'assets') dispatch(showHostLeftFilters(false));
    else if (entity === 'vulnsAssets') dispatch(showVulnsSidebarFilters(false));
    else if (entity === 'assetsGeneral') dispatch(showAssetsRightFilters(false));
    else if (entity === 'vulnsGeneral') dispatch(showVulnsGeneralRightFilters(false));
  };

  const clearAll = () => {
    if (isFiltering) {
      dispatch(clearFilters(entity));
      if (entity === 'vulns') dispatch(newGetVulns());
      else if (entity === 'assets') dispatch(getData());
      else if (entity === 'vulnsAssets') dispatch(getVulnsByAsset());
      else if (entity === 'assetsGeneral') dispatch(getHostsData());
      else if (entity === 'vulnsGeneral') dispatch(getVulnsGeneral());
    }
  };
  return (
    <FiltersHeader>
      <HeaderTitle isFiltering={ isFiltering }>Filters</HeaderTitle>
      <ButtonsContainer>
        <ClearAll onClick={ clearAll }>Clear All</ClearAll>
        <Close onClick={ setHideFilter } />
      </ButtonsContainer>
    </FiltersHeader>
  );
};

Header.propTypes = {
  entity: PropTypes.string.isRequired
};

export default Header;
